import cx from 'classnames'
import {AppearanceProvider} from 'components/common/CartItemBuilder/providers/AppearanceProvider'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {Button} from 'components/system/Button'
import * as ga4Events from 'ga4Events'
import {useAddBookingMutation} from 'hooks/ventrata/useAddBookingMutation'
import {useCurrency, useTravelerPath} from 'providers/EnvironmentProvider'
import {useOrderDetailsMutators} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {convertUnitCounterMapToRequestUnitItems} from 'utils/convertUnitCounterMapToRequestUnitItems'
import {ApplyButton} from '../../ApplyButton'

type Props = {
  onError: (error: unknown) => void
}

export const BookButton = ({onError}: Props) => {
  const builderManager = AppearanceProvider.useManager()
  const product = VentrataDataProvider.useProduct('optional')
  const unitCounters = InputProvider.useUnitCounters('optional')
  const availabilityId = InputProvider.useAvailabilityId('optional')
  const optionId = InputProvider.useOptionId('optional')
  const productId = InputProvider.useProductId()
  const cartItemId = InputProvider.useId()
  const currency = useCurrency()
  const optionalOrder = OrderProvider.useOrder('optional')
  const setOrder = OrderProvider.useOrderSetter()
  const addBookingMutation = useAddBookingMutation()
  const {setCrossSellingFlag} = useOrderDetailsMutators()
  const option = VentrataDataProvider.useOption(optionId, 'optional')
  const crossSellingFlag = builderManager.action === 'creatingMore'
  const checkoutPath = useTravelerPath()

  const addBooking = addBookingMutation.mutate

  const bookNow = useCallback(() => {
    ga4Events.bookNowButton({product, option})

    addBooking(
      {
        optionalOrderId: optionalOrder?.id,
        bookingUuid: cartItemId,
        availabilityId,
        productId,
        optionId,
        unitItems: convertUnitCounterMapToRequestUnitItems(unitCounters),
        currency,
      },
      {
        onSuccess(order) {
          setOrder(order)
          setCrossSellingFlag(cartItemId, crossSellingFlag)
          ga4Events.addToCart({order, bookingUuid: cartItemId, crossSellingFlag})
          builderManager.onClose()
          window.location.href = checkoutPath
        },
        onError,
      }
    )
  }, [
    builderManager,
    cartItemId,
    currency,
    addBooking,
    availabilityId,
    optionId,
    productId,
    unitCounters,
    optionalOrder?.id,
    setOrder,
    checkoutPath,
    crossSellingFlag,
    setCrossSellingFlag,
    option,
    product,
    onError,
  ])

  return (
    <ApplyButton
      onClick={bookNow}
      onError={onError}
      render={({onClick, disabled}) => {
        return (
          <Button.Primary.Orange
            onClick={onClick}
            autoExpanded
            className={cx(disabled ? '!bg-inactive-gray' : '!bg-theme')}
          >
            Book Now
          </Button.Primary.Orange>
        )
      }}
    />
  )
}
